module.exports = __webpack_public_path__ + "static/media/vkontakte.6dcf5555.svg";